const Icon = ({ className, type, ...props }) => (
  <span className={className} {...props}>
    <i className={`fa fa-${ type }`} aria-hidden="true" />
  </span>
);

export default Icon;
